if(typeof require !== 'undefined'){
  MailtoFactory = require('../mailtos/mailto-factory.js');
  _ = require('lodash');
}

class SponsorAgentInviteMailtoString extends MailtoFactory{

  constructor(options){
    if(!options.agent)
      console.warn('Agent is required for mailto.');

    super(options);
  }

  _to(){
    return '';
  }

  _subject(){
    return 'I\'ve been trying out Homebot';
  }

  _getClientNamesForSubject(){
    return this._getClientNames()[0];
  }

  _getClientNamesForBody(){
    return this._getClientNames()
      .slice(0,5)
      .join(', ');
  }

  _getClientNames(){
    return this.rea.homes.map((home) => {
      return `${home.users[0].first_name} ${home.users[0].last_name}`;
    });
  }

  _body(){
    return `Hello,

I'm providing a new service called Homebot to all of my clients (and they love it). It monitors their home value, loans, and market conditions to optimize home finance decisions (e.g. when to refi, when to buy/sell/rent, etc).

There's a version for real estate agents now and if you're interested, I'd be happy to co-sponsor it for you!

Click on this link to see what it looks like and sign up (http://get.homebotapp.com/agent/).

Or give me a call to see it or ask questions!

${this.agent.first_name} ${this.agent.last_name}`;
  }

}


if(typeof module !== 'undefined' && module.exports)
  module.exports = SponsorAgentInviteMailtoString;
else if(typeof window !== 'undefined')
  window.SponsorAgentInviteMailtoString = SponsorAgentInviteMailtoString;
